import { useEffect, useState } from 'react';
import generic from '../assets/bank-logos/generic.png';
import sanitize from 'sanitize-filename';

export const useBankLogo = (name: string) => {
	const [src, setSrc] = useState<string>();

	useEffect(() => {
		load(name)
			.then((source) => {
				setSrc(source);
			})
			.catch((error) => {
				setSrc(generic);
			});
	}, [name]);

	return src;
};

async function load(bankName: string): Promise<string> {
	const name = sanitize(bankName);
	const module = await import(`../assets/bank-logos/${name}.png`);
	return module.default as string;
}
